/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/12/2024 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import TextField from "../ui/TextField";
import React, { Fragment, useState, useEffect } from "react";
import { NumericFormat } from 'react-number-format';

import { Modal, Box, MenuItem, Typography } from "@mui/material";
import { NumberFormat$ } from "../../settings/utils";
import { useVentas } from '../../context/Ventas/VentasContext'
import { useSesion } from "../../context/System/SesionContext";
import { useInventarios } from "../../context/Inventarios/InventariosContext";
import { useDoubleClickPrevention } from '../../hooks/useDoubleClickPrevention';

// Estilos para el modal con efecto suavizado de desplazamiento
const modalStyle = {
    position: 'fixed',
    top: '25%',
    right: '9%',
    width: '80vw',
    height: '45vh',
    maxWidth: '80vw',
    maxHeight: '60vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateX(300%)',
    transition: 'transform 0.5s ease-in-out',
    overflowY: 'auto',
    overflowX: 'auto'
};

const getDatos = () => ({
    folioapartado: 0,
    idpartida: 0,
    clavearticulo: "",
    medida: 0,
    cantidadarticulo: 0,
});

export default function ModalCancelacionApartados(props) {
    const { openModalCancelacionApartado, datosApartado = {}, handleCloseModalCancelacionApartados, handleCancelarApartado } = props;

    const { listaAlmacenesExhibidoresGeneral = [], handleObtenerAlmacenesExhibidores } = useInventarios();

    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    const [almacenExhibidor, setAlmacenExhibidor] = useState("");

    const [modalVisible, setModalVisible] = useState(false);
    const [internalOpen, setInternalOpen] = useState(false);
    const { parametrosCajaForm } = useSesion();

    const modalVisibleStyle = {
        transform: modalVisible ? 'translateX(0)' : 'translateX(300%)',
    };

    const listaAlmacenesExhibidoresOrdenada = (listaAlmacenesExhibidoresGeneral || []).slice().sort((c, d) => c.almacenexhibidor.localeCompare(d.almacenexhibidor));
    const listaOrdenadaAlmacenesExhibidores = listaAlmacenesExhibidoresOrdenada.map(y => y.almacenexhibidor.trim());

    const handleAlmacenChange = (e) => {
        setAlmacenExhibidor(e.target.value);
    };

    const handleCancelar = () => {
        executeWithProtection(() => {
            if (!almacenExhibidor.trim()) {
                return;
            }

            if (almacenExhibidor.trim().toUpperCase() === "APARTADOS") {
                return;
            }

            if (!datosApartado?.folioapartado || !datosApartado?.idpartida || 
                !datosApartado?.clavearticulo || !datosApartado?.medida || 
                !datosApartado?.cantidadarticulo) {
                return;
            }

            const caja = parametrosCajaForm.caja.trim();

            const nuevosDatosApartado = {
                folioapartado: datosApartado.folioapartado,
                idpartida: datosApartado.idpartida,
                clavearticulo: datosApartado.clavearticulo,
                medida: datosApartado.medida,
                cantidadarticulo: datosApartado.cantidadarticulo,
                caja: caja,
                almacenexhibidor: almacenExhibidor.trim()
            };

            handleCancelarApartado(nuevosDatosApartado);
        });
    };

    // Efecto para manejar la apertura/cierre con retardo para permitir la animación
    useEffect(() => {
        if (openModalCancelacionApartado) {
            setInternalOpen(true);
            setTimeout(() => {
                setModalVisible(true);
            }, 50);
        } else {
            setModalVisible(false);
            setTimeout(() => {
                setInternalOpen(false);
            }, 500);
        }
        if (listaAlmacenesExhibidoresGeneral.length === 0) {
            handleObtenerAlmacenesExhibidores("GENERAL");
        }
    }, [openModalCancelacionApartado]);

    return (
        <Modal
            open={internalOpen}
            onClose={handleCloseModalCancelacionApartados}
            aria-labelledby="menu-modal-title"
            aria-describedby="menu-modal-description"
            closeAfterTransition
        >
            <Box sx={{ ...modalStyle, ...modalVisibleStyle }}>
                <Fragment>
                    <div className="venta-detalles-container">
                        <div className="detalle-item">
                            <span className="detalle-text">Folio apartado:</span> {datosApartado.folioapartado}
                            <span className="detalle-text">ID Partida:</span> {datosApartado.idpartida}
                            <span className="detalle-text">Descripción artículo:</span> {datosApartado.descripcion}
                            <span className="detalle-text">Medida:</span> {datosApartado.medida}
                            <span className="detalle-text">Cantidad:</span> {datosApartado.cantidadarticulo}
                        </div>
                    </div>
                    <div className="containerCobroVentas">
                        <TextField autoComplete="off"
                            label="Almacén/Exhibidor destino:"
                            value={almacenExhibidor}
                            onChange={handleAlmacenChange}
                            sx={{ margin: '.5rem .3rem', width: '240px' }}
                            select
                            required
                        >
                            <MenuItem value="">--Seleccionar--</MenuItem>
                            {listaOrdenadaAlmacenesExhibidores.map((nombre) => (
                                <MenuItem key={nombre} value={nombre}>
                                    {nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                        <button className="cambioCostoApartadoButton" onClick={handleCancelar} disabled={isProcessing}>Cancelar apartado</button>
                    </div>
                </Fragment>
            </Box>
        </Modal>
    );
}
